export function buildListMessage(
	error?: any,
	isLoading?: boolean,
	pagedResults?: {
		resultCount?: number;
		results?: any[];
		pageNumber?: number;
	}
): string {
	let listMessage = '';

	if (pagedResults && pagedResults.resultCount < 1) {
		listMessage = 'No results to display';
	}
	if (!pagedResults || isLoading) {
		listMessage = 'Loading...';
	}
	if (error) {
		listMessage = 'Error loading list.';
	}

	return listMessage;
}
